import { Box } from '@material-ui/core';
import { LenderName } from '@nemuru-eng/js-api-client';

import { LenderIcons } from '@/components/modules/Application/components/PaymentMethod/_shared/components/LenderIcons';
import { PaymentHeaderWrapper } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodHeader/components/PaymentHeaderWrapper';
import { PaymentMethodHeaderProps } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/types/PaymentMethodHeaderProps';
import { AbstractLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractLoanPaymentMethod';
import { AbstractPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractPaymentMethod';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { IconByAllowedPaymentMethodType } from '@/components/shared/components/PricingsTable/constants/IconByAllowedPaymentMethodType';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useScreen } from '@/hooks/useScreen';

export const AutoLoanPaymentHeaderComponent = <T extends AbstractPaymentMethod>({
  paymentMethodEntity,
  hasLenders,
}: PaymentMethodHeaderProps<T>) => {
  const { getTextIdTranslation } = useTranslation();
  const { xs, sm, md, lg } = useScreen();

  const showProvidersLogos = lg || (sm && !md) || (xs && !sm);

  return (
    <PaymentHeaderWrapper>
      <Icon>{IconByAllowedPaymentMethodType(paymentMethodEntity.paymentMethodType)}</Icon>
      <Box
        display="flex"
        flexDirection={'column'}
        flexGrow={1}
        alignItems={sm ? 'flex-start' : 'center'}
        flexShrink={0}
      >
        <Font variant="body2">{getTextIdTranslation(paymentMethodEntity.paymentMethodType)}</Font>
        <Box display="flex" alignItems={'center'} maxHeight={'28px'}>
          <Font variant="body1" style={{ fontWeight: 'bold' }}>
            {!paymentMethodEntity.selectedConditionsGroup ? (
              getTextIdTranslation('SELECT_CONDITION_FROM_SIMULATOR')
            ) : (
              <>
                {getTextIdTranslation(
                  paymentMethodEntity.selectedConditionsGroup.instalmentTotalAmount().hasMultiple
                    ? 'FROM_AMOUNT'
                    : 'FOR',
                )?.toLowerCase()}{' '}
                {paymentMethodEntity.selectedConditionsGroup.instalmentTotalAmount().string}{' '}
                {getTextIdTranslation('IN')} {paymentMethodEntity.selectedConditionsGroup.conditions[0].term}{' '}
                {getTextIdTranslation('MONTHS')}
              </>
            )}
          </Font>
        </Box>
      </Box>
      {hasLenders && showProvidersLogos && (
        <Box minWidth={0} overflow="hidden">
          <LenderIcons
            allLenderNames={
              (paymentMethodEntity as unknown as AbstractLoanPaymentMethod).getAllProviderNames() as LenderName[]
            }
            activeLenderNames={
              (paymentMethodEntity as unknown as AbstractLoanPaymentMethod).getActiveProviderNames() as LenderName[]
            }
            collapseAfter={3}
          />
        </Box>
      )}
    </PaymentHeaderWrapper>
  );
};
